module.exports = __webpack_public_path__ + "ad3039695dd79fa1557a3dfac2e7d809.MP3";